"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collector = void 0;
var CollectorRegistry_1 = require("./CollectorRegistry");
var utils_1 = require("./utils");
var Collector = (function () {
    function Collector(config) {
        this.registry = CollectorRegistry_1.defaultRegistry;
        this.labels = [];
        if (config.registry) {
            this.registry = config.registry;
        }
        if ((0, utils_1.isValidCollectorName)(config.name)) {
            this.name = config.name;
        }
        else {
            throw new Error('Collector name is invalid, it MUST follow regex /[a-zA-Z_:][a-zA-Z0-9_:]*/');
        }
        if (config.labels) {
            if ((0, utils_1.isValidLabels)(config.labels)) {
                this.labels = config.labels;
            }
            else {
                throw new Error('Labels may contain invalid name, it MUST follow regex /[a-zA-Z_][a-zA-Z0-9_]*/');
            }
        }
        this.help = config.help;
        if (config.registry) {
            this.registry = config.registry;
        }
        this.registry.register(this);
    }
    Collector.prototype.collect = function () {
        return [];
    };
    Collector.prototype.reset = function () {
    };
    return Collector;
}());
exports.Collector = Collector;
//# sourceMappingURL=Collector.js.map